import { jsx as _jsx } from "react/jsx-runtime";
import { alpha } from "@mui/material/styles";
import { ElementChip } from "./base/ElementChip";
import { ValueIcon } from "./valueIcons/ValueIcon";
import { DIET_FALLBACK_ICON, DIET_ICONS, findValueIcon } from "./valueIcons/valueIconMaps";
var COLOR = "#4CAF50";
var ICON_SX = { fontSize: 18, color: COLOR };
/** The value's own icon, else the diet icon. */
export function DietIcon(_a) {
    var _b;
    var value = _a.value;
    var spec = (_b = findValueIcon(DIET_ICONS, value)) !== null && _b !== void 0 ? _b : DIET_FALLBACK_ICON;
    return _jsx(ValueIcon, { glyph: spec.glyph, off: spec.off, sx: ICON_SX });
}
export function DietElement(_a) {
    var label = _a.label, value = _a.value, _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, onDelete = _a.onDelete;
    if (!label)
        return null;
    return (_jsx(ElementChip, { text: label, startIcon: _jsx(DietIcon, { value: value }), borderColor: alpha(COLOR, 0.28), active: active, onClick: onClick, onDelete: onDelete }));
}
